import { useEffect, useRef, useState } from "react";

const InputCode = ({
  length,
  loading,
  onChange,
}) => {
  const [code, setCode] = useState([...Array(length)].map(() => ""));
  const inputs = useRef([]);

  useEffect(() => {
    if (onChange) {
      onChange(code.join(""));
    }
  }, [code]);

  const processInput = (num, slot) => {
    if (/[^0-9]/.test(num)) return;
    const newCode = [...code];
    newCode[slot] = num;
    setCode(newCode);

    if (num) {
      if (slot !== length - 1 && !newCode[slot + 1]) {
        inputs.current[slot + 1].focus();
      }
    } else {
      if (slot !== 0) {
        inputs.current[slot - 1].focus();
      }
    }
  };

  const handleKeyDownInput = async (event, inputIndex) => {
    const { ctrlKey, key } = event;

    if (ctrlKey && key === "v") {
      const selectedText = await navigator.clipboard.readText();
      if (selectedText) {
        const TextStrings = selectedText.split("").slice(0, 6);
        setCode(TextStrings);
      }
    }
  };

  const handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData("text");
    if (/[^0-9]/.test(pastedValue)) return;

    let inputNumbers = [];

    const pastedValueArr = pastedValue.toString().split("");

    for (let i = 0; i < 6; i++) {
      inputNumbers.push(pastedValueArr[i] || "");
    }

    setCode(inputNumbers);
  };

  return (
    <div className="verify-code-inputs">
      {code.map((num, idx) => {
        return (
          <input
            key={idx}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={num}
            autoFocus={!code[0].length && idx === 0}
            readOnly={loading}
            onChange={(e) => processInput(e.target.value, idx)}
            ref={(ref) => inputs.current.push(ref)}
            onKeyDown={(event) => handleKeyDownInput(event, idx)}
            onPaste={handlePaste}
          />
        );
      })}
    </div>
  );
};

export default InputCode;
